import e from "react";
import { useAtom as d } from "jotai";
import m from "classnames";
import u from "./index127.mjs";
import l from "./index128.mjs";
import { alertAtom as E } from "./index51.mjs";
const b = ({
  title: n,
  subTitle: a,
  icon: o,
  actions: s,
  setAlertData: c,
  classes: i
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: m(l.body, i) }, o ? /* @__PURE__ */ e.createElement("div", { "data-testid": "alert-icon", className: l.icon }, /* @__PURE__ */ e.createElement(o, null)) : null, /* @__PURE__ */ e.createElement("div", { "data-testid": "alert-title", className: l.title }, n), a ? /* @__PURE__ */ e.createElement("div", { "data-testid": "alert-sub_title", className: l.sub_title }, a) : null), /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "alert-actions",
    className: m(l.actions, l.actions_desktop)
  },
  s ? s.map((t, r) => /* @__PURE__ */ e.createElement(
    "button",
    {
      "data-testid": t.dataTestId || `alert-action-${r}`,
      className: m(l.action_button, t.className, {
        [l.button_secondary]: t.secondary
      }),
      type: "button",
      key: t.label,
      onClick: () => {
        t.onClick && t.onClick(), c(null);
      }
    },
    t.label
  )) : null
)), y = () => {
  const [n, a] = d(E);
  if (!n)
    return null;
  const { title: o, subTitle: s, icon: c, actions: i, onClose: t } = n;
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "alert", className: l.alert }, /* @__PURE__ */ e.createElement("div", { className: l.alert_container }, t ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "close-icon",
      onClick: () => {
        t(), a(null);
      },
      className: l.icon_close,
      "aria-label": I18n.t("booking_engine.information.close"),
      role: "button",
      tabIndex: 0,
      onKeyDown: (r) => {
        (r.key === "Enter" || r.key === " ") && (t(), a(null));
      }
    },
    /* @__PURE__ */ e.createElement(u, null)
  ) : null, /* @__PURE__ */ e.createElement(
    b,
    {
      title: o,
      subTitle: s,
      icon: c,
      actions: i,
      setAlertData: a
    }
  )));
};
export {
  y as Alert,
  b as AlertContent
};
